import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import { IconButton, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { ratingApi } from './rating.queries';

export default function RatingPicker(props) {
	const { rateableType, rateableId, field, value } = props;

	const [rating, setRating] = useState(value);

	const useSet = ratingApi.useSet();

	useEffect(() => {
		setRating(value);
	}, [rateableType, rateableId, field, value]);

	if (!rateableType || !rateableId) {
		return;
	}

	const save = async (newRating) => {
		const result = await useSet.mutateAsync({  rateableType, rateableId, field, value: newRating  });
		setRating(newRating);
	}

	const iconSx = { fontSize: 40 };

	return (
		<Stack alignItems="center">
			<IconButton onClick={() => save(1)}>
				<SentimentVeryDissatisfiedIcon sx={iconSx} color={rating == 1 ? 'error' : ''} />
			</IconButton>
			<IconButton onClick={() => save(2)}>
				<SentimentDissatisfiedIcon sx={iconSx} color={rating == 2 ? 'error' : ''} />
			</IconButton>
			<IconButton onClick={() => save(3)}>
				<SentimentNeutralIcon sx={iconSx} color={rating == 3 ? 'warning' : ''} />
			</IconButton>
			<IconButton onClick={() => save(4)}>
				<SentimentSatisfiedIcon sx={iconSx} color={rating == 4 ? 'success' : ''} />
			</IconButton>
			<IconButton onClick={() => save(5)}>
				<SentimentVerySatisfiedIcon sx={iconSx} color={rating == 5 ? 'success' : ''} />
			</IconButton>
		</Stack>
	);
}
